import { c as _c } from "react/compiler-runtime";
import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const CSSScrollSnapCarousel = t0 => {
  const $ = _c(18);
  const {
    slides: t1,
    className: t2,
    height: t3,
    onSlideChange
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const slides = t4;
  const className = t2 === undefined ? "" : t2;
  const height = t3 === undefined ? "medium" : t3;
  const scrollContainerRef = useRef(null);
  let t5;
  if ($[2] !== onSlideChange) {
    t5 = () => {
      if (!scrollContainerRef.current || !onSlideChange) {
        return;
      }
      const container = scrollContainerRef.current;
      const {
        scrollLeft
      } = container;
      const slideWidth = container.clientWidth;
      const currentSlide = Math.round(scrollLeft / slideWidth);
      onSlideChange(currentSlide);
    };
    $[2] = onSlideChange;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleScroll = t5;
  let t6;
  if ($[4] !== className) {
    t6 = classNames("CSSScrollSnapCarousel", className);
    $[4] = className;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const t7 = height === "small";
  const t8 = height === "medium";
  let t9;
  if ($[6] !== t7 || $[7] !== t8) {
    t9 = classNames("flex overflow-x-auto overflow-y-hidden w-full scroll-smooth snap-x snap-mandatory [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden", {
      "h-64": t7,
      "h-96": t8
    });
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== slides) {
    t10 = slides.map(_temp);
    $[9] = slides;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== handleScroll || $[12] !== t10 || $[13] !== t9) {
    t11 = <div ref={scrollContainerRef} className={t9} onScroll={handleScroll}>{t10}</div>;
    $[11] = handleScroll;
    $[12] = t10;
    $[13] = t9;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t6) {
    t12 = <div className={t6}>{t11}</div>;
    $[15] = t11;
    $[16] = t6;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  return t12;
};
CSSScrollSnapCarousel.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    slide: PropTypes.node.isRequired
  })).isRequired,
  className: PropTypes.string,
  height: PropTypes.oneOf(['small', 'medium']),
  onSlideChange: PropTypes.func
};
export default CSSScrollSnapCarousel;
function _temp(t0) {
  const {
    key,
    slide
  } = t0;
  return <div key={key} className="flex-shrink-0 w-full h-full snap-start">{slide}</div>;
}